module.exports = __webpack_public_path__ + "img/u0.27af63be.jpg";